<template lang="pug">
  .container-items
    container-item(v-for="(type, index) in types", :type="type", :key="index")
</template>
<script>
import ContainerItem from '@/components/BlocksEditor/BuildingEquipment/ContainerItems/ContainerItem'
import Carcass from '@/components/BlocksEditor/BuildingEquipment/ContainerItems/ContainerItem/Carcass'
import ExternalFinishing
  from '@/components/BlocksEditor/BuildingEquipment/ContainerItems/ContainerItem/ExternalFinishing'
import Roof from '@/components/BlocksEditor/BuildingEquipment/ContainerItems/ContainerItem/Roof'
import Windows from '@/components/BlocksEditor/BuildingEquipment/ContainerItems/ContainerItem/Windows'
import Doors from '@/components/BlocksEditor/BuildingEquipment/ContainerItems/ContainerItem/Doors'
import Plumbing from '@/components/BlocksEditor/BuildingEquipment/ContainerItems/ContainerItem/Plumbing'
import Warming from '@/components/BlocksEditor/BuildingEquipment/ContainerItems/ContainerItem/Warming'
import InternalFinishing
  from '@/components/BlocksEditor/BuildingEquipment/ContainerItems/ContainerItem/InternalFinishing'
import Floor from '@/components/BlocksEditor/BuildingEquipment/ContainerItems/ContainerItem/Floor'
import Waterproofing from '@/components/BlocksEditor/BuildingEquipment/ContainerItems/ContainerItem/Waterproofing'
import Electric from '@/components/BlocksEditor/BuildingEquipment/ContainerItems/ContainerItem/Electric'
import Additional from '@/components/BlocksEditor/BuildingEquipment/ContainerItems/ContainerItem/Additional'
import { mapGetters } from 'vuex'
import Mounting from '@/components/BlocksEditor/BuildingEquipment/ContainerItems/ContainerItem/Mounting'

export default {
  name: 'ContainerItems',
  components: { ContainerItem },
  data() {
    return {
      types: [
        {
          id: 'Carcass',
          title: 'EQ_ITEM_CARCASS',
          component: Carcass,
        },
        {
          id: 'ExternalFinishing',
          title: 'EQ_ITEM_EXT_FINISHING',
          component: ExternalFinishing,
        },
        {
          id: 'Roof',
          title: 'EQ_ITEM_ROOF',
          component: Roof,
        },
        {
          id: 'Windows',
          title: 'EQ_ITEM_WINDOWS',
          component: Windows,
        },
        {
          id: 'Doors',
          title: 'EQ_ITEM_DOORS',
          component: Doors,
        },
        {
          id: 'InternalFinishing',
          title: 'EQ_ITEM_INT_FINISHING',
          component: InternalFinishing,
        },
        {
          id: 'Floor',
          title: 'EQ_ITEM_FLOOR',
          component: Floor,
        },
        {
          id: 'Plumbing',
          title: 'EQ_ITEM_PLUMBING',
          component: Plumbing,
        },
        {
          id: 'Warming',
          title: 'EQ_ITEM_WARMING',
          component: Warming,
        },
        {
          id: 'Waterproofing',
          title: 'EQ_ITEM_WATERPROOF',
          component: Waterproofing,
        },
        {
          id: 'Electric',
          title: 'EQ_ITEM_ELECTRIC',
          component: Electric,
        },
        {
          id: 'Additional',
          title: 'EQ_ITEM_ADDITIONAL',
          component: Additional,
        },
        {
          id: 'Mounting',
          title: 'EQ_ITEM_MOUNTING',
          component: Mounting,
        }
      ]
    }
  },

  computed: {
    ...mapGetters([
      'carcassCost'
    ])
  }
}
</script>
